module.exports = __webpack_public_path__ + "media/images/JemTheMovie/web_background_image-059b416a2c0c7de601b1a9d6ea71fe47.png";